import { useQuery, QueryFunction } from 'react-query';
import { getAllUtilityVehicles, GetUtilityVehiclesQueries, UtilityVehicle } from '../../services/apiSLTP/materials/utilityVehicles';

type UseUtilityVehiclesQueryOptions = {
    queries?: GetUtilityVehiclesQueries;
};

const getUtilityVehicles: QueryFunction<UtilityVehicle[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseUtilityVehiclesQueryOptions];
    const { queries } = options;

    const response = await getAllUtilityVehicles(queries);
    return response.data;
};

export const useUtilityVehiclesQuery = (options: UseUtilityVehiclesQueryOptions) => {
    return useQuery(['utilityVehicles', options], getUtilityVehicles);
};
